/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ContainerIterator = /** @class */function () {
  /**
   * @internal
   */
  function ContainerIterator(iteratorType) {
    if (iteratorType === void 0) {
      iteratorType = 0 /* IteratorType.NORMAL */;
    }
    this.iteratorType = iteratorType;
  }
  /**
   * @param iter - The other iterator you want to compare.
   * @returns Whether this equals to obj.
   * @example
   * container.find(1).equals(container.end());
   */
  ContainerIterator.prototype.equals = function (iter) {
    return this._node === iter._node;
  };
  return ContainerIterator;
}();
var Base = /** @class */function () {
  function Base() {
    /**
     * @description Container's size.
     * @internal
     */
    this._length = 0;
  }
  Object.defineProperty(Base.prototype, "length", {
    /**
     * @returns The size of the container.
     * @example
     * const container = new Vector([1, 2]);
     * console.log(container.length); // 2
     */
    get: function () {
      return this._length;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * @returns The size of the container.
   * @example
   * const container = new Vector([1, 2]);
   * console.log(container.size()); // 2
   */
  Base.prototype.size = function () {
    return this._length;
  };
  /**
   * @returns Whether the container is empty.
   * @example
   * container.clear();
   * console.log(container.empty());  // true
   */
  Base.prototype.empty = function () {
    return this._length === 0;
  };
  return Base;
}();
var Container = /** @class */function (_super) {
  __extends(Container, _super);
  function Container() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return Container;
}(Base);

/**
 * @description Determine whether the type of key is `object`.
 * @param key - The key want to check.
 * @returns Whether the type of key is `object`.
 * @internal
 */
function checkObject(key) {
  var t = typeof key;
  return t === 'object' && key !== null || t === 'function';
}

/**
 * @description Throw an iterator access error.
 * @internal
 */
function throwIteratorAccessError() {
  throw new RangeError('Iterator access denied!');
}

var HashContainerIterator = /** @class */function (_super) {
  __extends(HashContainerIterator, _super);
  /**
   * @internal
   */
  function HashContainerIterator(node, header, iteratorType) {
    var _this = _super.call(this, iteratorType) || this;
    _this._node = node;
    _this._header = header;
    if (_this.iteratorType === 0 /* IteratorType.NORMAL */) {
      _this.pre = function () {
        if (this._node._pre === this._header) {
          throwIteratorAccessError();
        }
        this._node = this._node._pre;
        return this;
      };
      _this.next = function () {
        if (this._node === this._header) {
          throwIteratorAccessError();
        }
        this._node = this._node._next;
        return this;
      };
    } else {
      _this.pre = function () {
        if (this._node._next === this._header) {
          throwIteratorAccessError();
        }
        this._node = this._node._next;
        return this;
      };
      _this.next = function () {
        if (this._node === this._header) {
          throwIteratorAccessError();
        }
        this._node = this._node._pre;
        return this;
      };
    }
    return _this;
  }
  HashContainerIterator.prototype.isAccessible = function () {
    return this._node !== this._header;
  };
  return HashContainerIterator;
}(ContainerIterator);
var HashContainer = /** @class */function (_super) {
  __extends(HashContainer, _super);
  /**
   * @internal
   */
  function HashContainer() {
    var _this = _super.call(this) || this;
    /**
     * @internal
     */
    _this._objMap = [];
    /**
     * @internal
     */
    _this._originMap = {};
    /**
     * @description Unique symbol used to tag object.
     */
    _this.HASH_TAG = Symbol('@@HASH_TAG');
    Object.setPrototypeOf(_this._originMap, null);
    _this._header = {};
    _this._header._pre = _this._header._next = _this._head = _this._tail = _this._header;
    return _this;
  }
  /**
   * @internal
   */
  HashContainer.prototype._eraseNode = function (node) {
    var _pre = node._pre,
      _next = node._next;
    _pre._next = _next;
    _next._pre = _pre;
    if (node === this._head) {
      this._head = _next;
    }
    if (node === this._tail) {
      this._tail = _pre;
    }
    this._length -= 1;
  };
  /**
   * @internal
   */
  HashContainer.prototype._set = function (key, value, isObject) {
    if (isObject === undefined) isObject = checkObject(key);
    var newTail;
    if (isObject) {
      var index = key[this.HASH_TAG];
      if (index !== undefined) {
        this._objMap[index]._value = value;
        return this._length;
      }
      Object.defineProperty(key, this.HASH_TAG, {
        value: this._objMap.length,
        configurable: true
      });
      newTail = {
        _key: key,
        _value: value,
        _pre: this._tail,
        _next: this._header
      };
      this._objMap.push(newTail);
    } else {
      var node = this._originMap[key];
      if (node) {
        node._value = value;
        return this._length;
      }
      this._originMap[key] = newTail = {
        _key: key,
        _value: value,
        _pre: this._tail,
        _next: this._header
      };
    }
    if (this._length === 0) {
      this._head = newTail;
      this._header._next = newTail;
    } else {
      this._tail._next = newTail;
    }
    this._tail = newTail;
    this._header._pre = newTail;
    return ++this._length;
  };
  /**
   * @internal
   */
  HashContainer.prototype._findElementNode = function (key, isObject) {
    if (isObject === undefined) isObject = checkObject(key);
    if (isObject) {
      var index = key[this.HASH_TAG];
      if (index === undefined) return this._header;
      return this._objMap[index];
    } else {
      return this._originMap[key] || this._header;
    }
  };
  HashContainer.prototype.clear = function () {
    var HASH_TAG = this.HASH_TAG;
    this._objMap.forEach(function (el) {
      delete el._key[HASH_TAG];
    });
    this._objMap = [];
    this._originMap = {};
    Object.setPrototypeOf(this._originMap, null);
    this._length = 0;
    this._head = this._tail = this._header._pre = this._header._next = this._header;
  };
  /**
   * @description Remove the element of the specified key.
   * @param key - The key you want to remove.
   * @param isObject - Tell us if the type of inserted key is `object` to improve efficiency.<br/>
   *                   If a `undefined` value is passed in, the type will be automatically judged.
   * @returns Whether erase successfully.
   */
  HashContainer.prototype.eraseElementByKey = function (key, isObject) {
    var node;
    if (isObject === undefined) isObject = checkObject(key);
    if (isObject) {
      var index = key[this.HASH_TAG];
      if (index === undefined) return false;
      delete key[this.HASH_TAG];
      node = this._objMap[index];
      delete this._objMap[index];
    } else {
      node = this._originMap[key];
      if (node === undefined) return false;
      delete this._originMap[key];
    }
    this._eraseNode(node);
    return true;
  };
  HashContainer.prototype.eraseElementByIterator = function (iter) {
    var node = iter._node;
    if (node === this._header) {
      throwIteratorAccessError();
    }
    this._eraseNode(node);
    return iter.next();
  };
  HashContainer.prototype.eraseElementByPos = function (pos) {
    if (pos < 0 || pos > this._length - 1) {
      throw new RangeError();
    }
    var node = this._head;
    while (pos--) {
      node = node._next;
    }
    this._eraseNode(node);
    return this._length;
  };
  return HashContainer;
}(Container);

var HashSetIterator = /** @class */function (_super) {
  __extends(HashSetIterator, _super);
  function HashSetIterator(node, header, container, iteratorType) {
    var _this = _super.call(this, node, header, iteratorType) || this;
    _this.container = container;
    return _this;
  }
  Object.defineProperty(HashSetIterator.prototype, "pointer", {
    get: function () {
      if (this._node === this._header) {
        throwIteratorAccessError();
      }
      return this._node._key;
    },
    enumerable: false,
    configurable: true
  });
  HashSetIterator.prototype.copy = function () {
    return new HashSetIterator(this._node, this._header, this.container, this.iteratorType);
  };
  return HashSetIterator;
}(HashContainerIterator);
var HashSet = /** @class */function (_super) {
  __extends(HashSet, _super);
  function HashSet(container) {
    if (container === void 0) {
      container = [];
    }
    var _this = _super.call(this) || this;
    var self = _this;
    container.forEach(function (el) {
      self.insert(el);
    });
    return _this;
  }
  HashSet.prototype.begin = function () {
    return new HashSetIterator(this._head, this._header, this);
  };
  HashSet.prototype.end = function () {
    return new HashSetIterator(this._header, this._header, this);
  };
  HashSet.prototype.rBegin = function () {
    return new HashSetIterator(this._tail, this._header, this, 1 /* IteratorType.REVERSE */);
  };

  HashSet.prototype.rEnd = function () {
    return new HashSetIterator(this._header, this._header, this, 1 /* IteratorType.REVERSE */);
  };

  HashSet.prototype.front = function () {
    return this._head._key;
  };
  HashSet.prototype.back = function () {
    return this._tail._key;
  };
  /**
   * @description Insert element to set.
   * @param key - The key want to insert.
   * @param isObject - Tell us if the type of inserted key is `object` to improve efficiency.<br/>
   *                   If a `undefined` value is passed in, the type will be automatically judged.
   * @returns The size of container after inserting.
   */
  HashSet.prototype.insert = function (key, isObject) {
    return this._set(key, undefined, isObject);
  };
  HashSet.prototype.getElementByPos = function (pos) {
    if (pos < 0 || pos > this._length - 1) {
      throw new RangeError();
    }
    var node = this._head;
    while (pos--) {
      node = node._next;
    }
    return node._key;
  };
  /**
   * @description Check key if exist in container.
   * @param key - The element you want to search.
   * @param isObject - Tell us if the type of inserted key is `object` to improve efficiency.<br/>
   *                   If a `undefined` value is passed in, the type will be automatically judged.
   * @returns An iterator pointing to the element if found, or super end if not found.
   */
  HashSet.prototype.find = function (key, isObject) {
    var node = this._findElementNode(key, isObject);
    return new HashSetIterator(node, this._header, this);
  };
  HashSet.prototype.forEach = function (callback) {
    var index = 0;
    var node = this._head;
    while (node !== this._header) {
      callback(node._key, index++, this);
      node = node._next;
    }
  };
  HashSet.prototype[Symbol.iterator] = function () {
    var node;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          node = this._head;
          _a.label = 1;
        case 1:
          if (!(node !== this._header)) return [3 /*break*/, 3];
          return [4 /*yield*/, node._key];
        case 2:
          _a.sent();
          node = node._next;
          return [3 /*break*/, 1];
        case 3:
          return [2 /*return*/];
      }
    });
  };

  return HashSet;
}(HashContainer);

export { HashSet };
//# sourceMappingURL=index.js.map
